import {createApplicationState} from '@services/ApplicationState';

export class ScrollService {
  private static singleton: ScrollService;
  private windowScrollY = 0;
  private container: HTMLElement | null = null;
  private state = createApplicationState();

  static create() {
    if (ScrollService.singleton) {
      return ScrollService.singleton;
    }
    return (ScrollService.singleton = new ScrollService());
  }

  stopScroll(target: HTMLElement) {
    if (!target) return;
    this.container = target;
    const container = this.container;

    this.windowScrollY = window.scrollY;
    container.style.transform = `translateY(${-this.windowScrollY}px)`;
    // container.style.zIndex = '6000'
    container.style.position = 'fixed';
    container.style.left = '0px';
    container.style.width = '100%';
    this.state.updateScrollStatus(true);
    return this.windowScrollY;
  }

  startScroll(scrollTo = true) {
    const container = this.container;
    if (!container) return;
    container.style.transform = '';
    container.style.zIndex = '';
    container.style.position = '';
    container.style.left = '';
    container.style.width = '';
    this.state.updateScrollStatus(false);
    if (scrollTo) {
      window.scrollTo({top: this.windowScrollY});
    }
    return this.windowScrollY;
  }
}
